"use strict";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("styled-components");

function n(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    default: e
  };
}

function o(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (n) {
    if ("default" !== n) {
      var o = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, o.get ? o : {
        enumerable: !0,
        get: function get() {
          return e[n];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}

var a,
    l = o(e),
    r = n(e),
    i = n(t);

function s(e, t) {
  return e[t];
}

function d(e, t) {
  return t.split(".").reduce(function (e, t) {
    var n = t.match(/[^\]\\[.]+/g);
    if (n && n.length > 1) for (var _t = 0; _t < n.length; _t++) {
      return e[n[_t]][n[_t + 1]];
    }
    return e[t];
  }, e);
}

function c() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var t = arguments.length > 1 ? arguments[1] : undefined;
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return [].concat(_toConsumableArray(e.slice(0, n)), [t], _toConsumableArray(e.slice(n)));
}

function g() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var t = arguments.length > 1 ? arguments[1] : undefined;
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "id";
  var o = e.slice(),
      a = s(t, n);
  return a ? o.splice(o.findIndex(function (e) {
    return s(e, n) === a;
  }), 1) : o.splice(o.findIndex(function (e) {
    return e === t;
  }), 1), o;
}

function u(e) {
  return e.map(function (e, t) {
    var n = Object.assign(Object.assign({}, e), {
      sortable: e.sortable || !!e.sortFunction || void 0
    });
    return e.id || (n.id = t + 1), n;
  });
}

function p(e, t) {
  return Math.ceil(e / t);
}

function b(e, t) {
  return Math.min(e, t);
}

!function (e) {
  e.ASC = "asc", e.DESC = "desc";
}(a || (a = {}));

var f = function f() {
  return null;
};

function m(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var o = {},
      a = _toConsumableArray(n);

  return t.length && t.forEach(function (t) {
    if (!t.when || "function" != typeof t.when) throw new Error('"when" must be defined in the conditional style object and must be function');
    t.when(e) && (o = t.style || {}, t.classNames && (a = [].concat(_toConsumableArray(a), _toConsumableArray(t.classNames))), "function" == typeof t.style && (o = t.style(e) || {}));
  }), {
    style: o,
    classNames: a.join(" ")
  };
}

function h(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "id";
  var o = s(e, n);
  return o ? t.some(function (e) {
    return s(e, n) === o;
  }) : t.some(function (t) {
    return t === e;
  });
}

function w(e, t) {
  return t ? e.findIndex(function (e) {
    return x(e.id, t);
  }) : -1;
}

function x(e, t) {
  return e == t;
}

function C(e, t) {
  var n = !e.toggleOnSelectedRowsChange;

  switch (t.type) {
    case "SELECT_ALL_ROWS":
      {
        var _n = t.keyField,
            _o = t.rows,
            _a = t.rowCount,
            _l = t.mergeSelections,
            _r = !e.allSelected,
            _i = !e.toggleOnSelectedRowsChange;

        if (_l) {
          var _t2 = _r ? [].concat(_toConsumableArray(e.selectedRows), _toConsumableArray(_o.filter(function (t) {
            return !h(t, e.selectedRows, _n);
          }))) : e.selectedRows.filter(function (e) {
            return !h(e, _o, _n);
          });

          return Object.assign(Object.assign({}, e), {
            allSelected: _r,
            selectedCount: _t2.length,
            selectedRows: _t2,
            toggleOnSelectedRowsChange: _i
          });
        }

        return Object.assign(Object.assign({}, e), {
          allSelected: _r,
          selectedCount: _r ? _a : 0,
          selectedRows: _r ? _o : [],
          toggleOnSelectedRowsChange: _i
        });
      }

    case "SELECT_SINGLE_ROW":
      {
        var _o2 = t.keyField,
            _a2 = t.row,
            _l2 = t.isSelected,
            _r2 = t.rowCount,
            _i2 = t.singleSelect;
        return _i2 ? _l2 ? Object.assign(Object.assign({}, e), {
          selectedCount: 0,
          allSelected: !1,
          selectedRows: [],
          toggleOnSelectedRowsChange: n
        }) : Object.assign(Object.assign({}, e), {
          selectedCount: 1,
          allSelected: !1,
          selectedRows: [_a2],
          toggleOnSelectedRowsChange: n
        }) : _l2 ? Object.assign(Object.assign({}, e), {
          selectedCount: e.selectedRows.length > 0 ? e.selectedRows.length - 1 : 0,
          allSelected: !1,
          selectedRows: g(e.selectedRows, _a2, _o2),
          toggleOnSelectedRowsChange: n
        }) : Object.assign(Object.assign({}, e), {
          selectedCount: e.selectedRows.length + 1,
          allSelected: e.selectedRows.length + 1 === _r2,
          selectedRows: c(e.selectedRows, _a2),
          toggleOnSelectedRowsChange: n
        });
      }

    case "SELECT_MULTIPLE_ROWS":
      {
        var _o3 = t.keyField,
            _a3 = t.selectedRows,
            _l3 = t.totalRows,
            _r3 = t.mergeSelections;

        if (_r3) {
          var _t3 = [].concat(_toConsumableArray(e.selectedRows), _toConsumableArray(_a3.filter(function (t) {
            return !h(t, e.selectedRows, _o3);
          })));

          return Object.assign(Object.assign({}, e), {
            selectedCount: _t3.length,
            allSelected: !1,
            selectedRows: _t3,
            toggleOnSelectedRowsChange: n
          });
        }

        return Object.assign(Object.assign({}, e), {
          selectedCount: _a3.length,
          allSelected: _a3.length === _l3,
          selectedRows: _a3,
          toggleOnSelectedRowsChange: n
        });
      }

    case "CLEAR_SELECTED_ROWS":
      {
        var _n2 = t.selectedRowsFlag;
        return Object.assign(Object.assign({}, e), {
          allSelected: !1,
          selectedCount: 0,
          selectedRows: [],
          selectedRowsFlag: _n2
        });
      }

    case "SORT_CHANGE":
      {
        var _o4 = t.sortDirection,
            _a4 = t.selectedColumn,
            _l4 = t.clearSelectedOnSort;
        return Object.assign(Object.assign(Object.assign({}, e), {
          selectedColumn: _a4,
          sortDirection: _o4,
          currentPage: 1
        }), _l4 && {
          allSelected: !1,
          selectedCount: 0,
          selectedRows: [],
          toggleOnSelectedRowsChange: n
        });
      }

    case "CHANGE_PAGE":
      {
        var _o5 = t.page,
            _a5 = t.paginationServer,
            _l5 = t.visibleOnly,
            _r4 = t.persistSelectedOnPageChange,
            _i3 = _a5 && _r4,
            _s = _a5 && !_r4 || _l5;

        return Object.assign(Object.assign(Object.assign(Object.assign({}, e), {
          currentPage: _o5
        }), _i3 && {
          allSelected: !1
        }), _s && {
          allSelected: !1,
          selectedCount: 0,
          selectedRows: [],
          toggleOnSelectedRowsChange: n
        });
      }

    case "CHANGE_ROWS_PER_PAGE":
      {
        var _n3 = t.rowsPerPage,
            _o6 = t.page;
        return Object.assign(Object.assign({}, e), {
          currentPage: _o6,
          rowsPerPage: _n3
        });
      }
  }
}

var y = t.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tpointer-events: none;\n\topacity: 0.4;\n"]))),
    v = i.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tposition: relative;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\theight: 100%;\n\tmax-width: 100%;\n\t", ";\n\t", ";\n"])), function (_ref) {
  var e = _ref.disabled;
  return e && y;
}, function (_ref2) {
  var e = _ref2.theme;
  return e.table.style;
}),
    R = t.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tposition: sticky;\n\tposition: -webkit-sticky; /* Safari */\n\ttop: 0;\n\tz-index: 1;\n"]))),
    S = i.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\twidth: 100%;\n\t", ";\n\t", ";\n"])), function (_ref3) {
  var e = _ref3.fixedHeader;
  return e && R;
}, function (_ref4) {
  var e = _ref4.theme;
  return e.head.style;
}),
    E = i.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: stretch;\n\twidth: 100%;\n\t", ";\n\t", ";\n"])), function (_ref5) {
  var e = _ref5.theme;
  return e.headRow.style;
}, function (_ref6) {
  var e = _ref6.dense,
      t = _ref6.theme;
  return e && t.headRow.denseStyle;
}),
    O = function O(e) {
  for (var _len = arguments.length, n = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    n[_key - 1] = arguments[_key];
  }

  return t.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\t@media screen and (max-width: ", "px) {\n\t\t\t", "\n\t\t}\n\t"])), 599, t.css.apply(t, [e].concat(n)));
},
    P = function P(e) {
  for (var _len2 = arguments.length, n = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    n[_key2 - 1] = arguments[_key2];
  }

  return t.css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\t@media screen and (max-width: ", "px) {\n\t\t\t", "\n\t\t}\n\t"])), 959, t.css.apply(t, [e].concat(n)));
},
    k = function k(e) {
  for (var _len3 = arguments.length, n = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    n[_key3 - 1] = arguments[_key3];
  }

  return t.css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\t@media screen and (max-width: ", "px) {\n\t\t\t", "\n\t\t}\n\t"])), 1280, t.css.apply(t, [e].concat(n)));
},
    D = function D(e) {
  return function (n) {
    for (var _len4 = arguments.length, o = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      o[_key4 - 1] = arguments[_key4];
    }

    return t.css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\t\t@media screen and (max-width: ", "px) {\n\t\t\t\t\t", "\n\t\t\t\t}\n\t\t\t"])), e, t.css.apply(t, [n].concat(o)));
  };
},
    H = i.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tbox-sizing: border-box;\n\tline-height: normal;\n\t", ";\n\t", ";\n"])), function (_ref7) {
  var e = _ref7.theme,
      t = _ref7.headCell;
  return e[t ? "headCells" : "cells"].style;
}, function (_ref8) {
  var e = _ref8.noPadding;
  return e && "padding: 0";
}),
    $ = i.default(H)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\tflex-grow: ", ";\n\tflex-shrink: 0;\n\tflex-basis: 0;\n\tmax-width: ", ";\n\tmin-width: ", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\n\t/* handle hiding cells */\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n"])), function (_ref9) {
  var e = _ref9.button,
      t = _ref9.grow;
  return 0 === t || e ? 0 : t || 1;
}, function (_ref10) {
  var e = _ref10.maxWidth;
  return e || "100%";
}, function (_ref11) {
  var e = _ref11.minWidth;
  return e || "100px";
}, function (_ref12) {
  var e = _ref12.width;
  return e && t.css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n\t\t\tmin-width: ", ";\n\t\t\tmax-width: ", ";\n\t\t"])), e, e);
}, function (_ref13) {
  var e = _ref13.right;
  return e && "justify-content: flex-end";
}, function (_ref14) {
  var e = _ref14.button,
      t = _ref14.center;
  return (t || e) && "justify-content: center";
}, function (_ref15) {
  var e = _ref15.compact,
      t = _ref15.button;
  return (e || t) && "padding: 0";
}, function (_ref16) {
  var e = _ref16.hide;
  return e && "sm" === e && O(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    display: none;\n  "])));
}, function (_ref17) {
  var e = _ref17.hide;
  return e && "md" === e && P(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    display: none;\n  "])));
}, function (_ref18) {
  var e = _ref18.hide;
  return e && "lg" === e && k(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    display: none;\n  "])));
}, function (_ref19) {
  var e = _ref19.hide;
  return e && Number.isInteger(e) && D(e)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    display: none;\n  "])));
}),
    j = t.css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n\tdiv:first-child {\n\t\twhite-space: ", ";\n\t\toverflow: ", ";\n\t\ttext-overflow: ellipsis;\n\t}\n"])), function (_ref20) {
  var e = _ref20.wrapCell;
  return e ? "normal" : "nowrap";
}, function (_ref21) {
  var e = _ref21.allowOverflow;
  return e ? "visible" : "hidden";
}),
    F = i.default($).attrs(function (e) {
  return {
    style: e.style
  };
})(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n\t", ";\n\t", ";\n\t", ";\n"])), function (_ref22) {
  var e = _ref22.renderAsCell;
  return !e && j;
}, function (_ref23) {
  var e = _ref23.theme,
      t = _ref23.isDragging;
  return t && e.cells.draggingStyle;
}, function (_ref24) {
  var e = _ref24.cellStyle;
  return e;
});

var T = l.memo(function (_ref25) {
  var e = _ref25.id,
      t = _ref25.column,
      n = _ref25.row,
      o = _ref25.rowIndex,
      a = _ref25.dataTag,
      r = _ref25.isDragging,
      i = _ref25.onDragStart,
      s = _ref25.onDragOver,
      c = _ref25.onDragEnd,
      g = _ref25.onDragEnter,
      u = _ref25.onDragLeave;

  var _m = m(n, t.conditionalCellStyles, ["rdt_TableCell"]),
      p = _m.style,
      b = _m.classNames;

  return l.createElement(F, {
    id: e,
    "data-column-id": t.id,
    role: "gridcell",
    className: b,
    "data-tag": a,
    cellStyle: t.style,
    renderAsCell: !!t.cell,
    allowOverflow: t.allowOverflow,
    button: t.button,
    center: t.center,
    compact: t.compact,
    grow: t.grow,
    hide: t.hide,
    maxWidth: t.maxWidth,
    minWidth: t.minWidth,
    right: t.right,
    width: t.width,
    wrapCell: t.wrap,
    style: p,
    isDragging: r,
    onDragStart: i,
    onDragOver: s,
    onDragEnd: c,
    onDragEnter: g,
    onDragLeave: u
  }, !t.cell && l.createElement("div", {
    "data-tag": a
  }, function (e, t, n, o) {
    if (!t) return null;
    if ("string" != typeof t && "function" != typeof t) throw new Error("selector must be a . delimited string eg (my.property) or function (e.g. row => row.field");
    return n && "function" == typeof n ? n(e, o) : t && "function" == typeof t ? t(e, o) : d(e, t);
  }(n, t.selector, t.format, o)), t.cell && t.cell(n, o, t, e));
});
var I = l.memo(function (_ref26) {
  var e = _ref26.name,
      _ref26$component = _ref26.component,
      t = _ref26$component === void 0 ? "input" : _ref26$component,
      _ref26$componentOptio = _ref26.componentOptions,
      n = _ref26$componentOptio === void 0 ? {
    style: {}
  } : _ref26$componentOptio,
      _ref26$indeterminate = _ref26.indeterminate,
      o = _ref26$indeterminate === void 0 ? !1 : _ref26$indeterminate,
      _ref26$checked = _ref26.checked,
      a = _ref26$checked === void 0 ? !1 : _ref26$checked,
      _ref26$disabled = _ref26.disabled,
      r = _ref26$disabled === void 0 ? !1 : _ref26$disabled,
      _ref26$onClick = _ref26.onClick,
      i = _ref26$onClick === void 0 ? f : _ref26$onClick;
  var s = t,
      d = "input" !== s ? n.style : function (e) {
    return Object.assign(Object.assign({
      fontSize: "18px"
    }, !e && {
      cursor: "pointer"
    }), {
      padding: 0,
      marginTop: "1px",
      verticalAlign: "middle",
      position: "relative"
    });
  }(r),
      c = l.useMemo(function () {
    return function (e) {
      for (var _len5 = arguments.length, t = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        t[_key5 - 1] = arguments[_key5];
      }

      var n;
      return Object.keys(e).map(function (t) {
        return e[t];
      }).forEach(function (o, a) {
        var l = e;
        "function" == typeof o && (n = Object.assign(Object.assign({}, l), _defineProperty({}, Object.keys(e)[a], o.apply(void 0, t))));
      }), n || e;
    }(n, o);
  }, [n, o]);
  return l.createElement(s, Object.assign({
    type: "checkbox",
    ref: function ref(e) {
      e && (e.indeterminate = o);
    },
    style: d,
    onClick: r ? f : i,
    name: e,
    "aria-label": e,
    checked: a,
    disabled: r
  }, c, {
    onChange: f
  }));
});
var A = i.default(H)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n\tflex: 0 0 48px;\n\tmin-width: 48px;\n\tjustify-content: center;\n\talign-items: center;\n\tuser-select: none;\n\twhite-space: nowrap;\n"])));

function _(_ref27) {
  var e = _ref27.name,
      t = _ref27.keyField,
      n = _ref27.row,
      o = _ref27.rowCount,
      a = _ref27.selected,
      r = _ref27.selectableRowsComponent,
      i = _ref27.selectableRowsComponentProps,
      s = _ref27.selectableRowsSingle,
      d = _ref27.selectableRowDisabled,
      c = _ref27.onSelectedRow;
  var g = !(!d || !d(n));
  return l.createElement(A, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    className: "rdt_TableCell",
    noPadding: !0
  }, l.createElement(I, {
    name: e,
    component: r,
    componentOptions: i,
    checked: a,
    "aria-checked": a,
    onClick: function onClick() {
      c({
        type: "SELECT_SINGLE_ROW",
        row: n,
        isSelected: a,
        keyField: t,
        rowCount: o,
        singleSelect: s
      });
    },
    disabled: g
  }));
}

var L = i.default.button(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n\tdisplay: inline-flex;\n\talign-items: center;\n\tuser-select: none;\n\twhite-space: nowrap;\n\tborder: none;\n\tbackground-color: transparent;\n\t", ";\n"])), function (_ref28) {
  var e = _ref28.theme;
  return e.expanderButton.style;
});

function M(_ref29) {
  var _ref29$disabled = _ref29.disabled,
      e = _ref29$disabled === void 0 ? !1 : _ref29$disabled,
      _ref29$expanded = _ref29.expanded,
      t = _ref29$expanded === void 0 ? !1 : _ref29$expanded,
      n = _ref29.expandableIcon,
      o = _ref29.id,
      a = _ref29.row,
      r = _ref29.onToggled;
  var i = t ? n.expanded : n.collapsed;
  return l.createElement(L, {
    "aria-disabled": e,
    onClick: function onClick() {
      return r && r(a);
    },
    "data-testid": "expander-button-".concat(o),
    disabled: e,
    "aria-label": t ? "Collapse Row" : "Expand Row",
    role: "button",
    type: "button"
  }, i);
}

var z = i.default(H)(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n\twhite-space: nowrap;\n\tfont-weight: 400;\n\tmin-width: 48px;\n\t", ";\n"])), function (_ref30) {
  var e = _ref30.theme;
  return e.expanderCell.style;
});

function N(_ref31) {
  var e = _ref31.row,
      _ref31$expanded = _ref31.expanded,
      t = _ref31$expanded === void 0 ? !1 : _ref31$expanded,
      n = _ref31.expandableIcon,
      o = _ref31.id,
      a = _ref31.onToggled,
      _ref31$disabled = _ref31.disabled,
      r = _ref31$disabled === void 0 ? !1 : _ref31$disabled;
  return l.createElement(z, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    noPadding: !0
  }, l.createElement(M, {
    id: o,
    row: e,
    expanded: t,
    expandableIcon: n,
    disabled: r,
    onToggled: a
  }));
}

var W = i.default.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tbox-sizing: border-box;\n\t", ";\n\t", ";\n"])), function (_ref32) {
  var e = _ref32.theme;
  return e.expanderRow.style;
}, function (_ref33) {
  var e = _ref33.extendedRowStyle;
  return e;
});
var B = l.memo(function (_ref34) {
  var e = _ref34.data,
      t = _ref34.ExpanderComponent,
      n = _ref34.expanderComponentProps,
      o = _ref34.extendedRowStyle,
      a = _ref34.extendedClassNames;
  var r = ["rdt_ExpanderRow"].concat(_toConsumableArray(a.split(" ").filter(function (e) {
    return "rdt_TableRow" !== e;
  }))).join(" ");
  return l.createElement(W, {
    className: r,
    extendedRowStyle: o
  }, l.createElement(t, Object.assign({
    data: e
  }, n)));
});
var G, V, U;
exports.Direction = void 0, (G = exports.Direction || (exports.Direction = {})).LTR = "ltr", G.RTL = "rtl", G.AUTO = "auto", exports.Alignment = void 0, (V = exports.Alignment || (exports.Alignment = {})).LEFT = "left", V.RIGHT = "right", V.CENTER = "center", exports.Media = void 0, (U = exports.Media || (exports.Media = {})).SM = "sm", U.MD = "md", U.LG = "lg";
var q = t.css(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n\t&:hover {\n\t\t", ";\n\t}\n"])), function (_ref35) {
  var e = _ref35.highlightOnHover,
      t = _ref35.theme;
  return e && t.rows.highlightOnHoverStyle;
}),
    Y = t.css(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n\t&:hover {\n\t\tcursor: pointer;\n\t}\n"]))),
    K = i.default.div.attrs(function (e) {
  return {
    style: e.style
  };
})(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: stretch;\n\talign-content: stretch;\n\twidth: 100%;\n\tbox-sizing: border-box;\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n"])), function (_ref36) {
  var e = _ref36.theme;
  return e.rows.style;
}, function (_ref37) {
  var e = _ref37.dense,
      t = _ref37.theme;
  return e && t.rows.denseStyle;
}, function (_ref38) {
  var e = _ref38.striped,
      t = _ref38.theme;
  return e && t.rows.stripedStyle;
}, function (_ref39) {
  var e = _ref39.highlightOnHover;
  return e && q;
}, function (_ref40) {
  var e = _ref40.pointerOnHover;
  return e && Y;
}, function (_ref41) {
  var e = _ref41.selected,
      t = _ref41.theme;
  return e && t.rows.selectedHighlightStyle;
});

function J(_ref42) {
  var _ref42$columns = _ref42.columns,
      e = _ref42$columns === void 0 ? [] : _ref42$columns,
      _ref42$conditionalRow = _ref42.conditionalRowStyles,
      t = _ref42$conditionalRow === void 0 ? [] : _ref42$conditionalRow,
      _ref42$defaultExpande = _ref42.defaultExpanded,
      n = _ref42$defaultExpande === void 0 ? !1 : _ref42$defaultExpande,
      _ref42$defaultExpande2 = _ref42.defaultExpanderDisabled,
      o = _ref42$defaultExpande2 === void 0 ? !1 : _ref42$defaultExpande2,
      _ref42$dense = _ref42.dense,
      a = _ref42$dense === void 0 ? !1 : _ref42$dense,
      r = _ref42.expandableIcon,
      _ref42$expandableRows = _ref42.expandableRows,
      i = _ref42$expandableRows === void 0 ? !1 : _ref42$expandableRows,
      d = _ref42.expandableRowsComponent,
      c = _ref42.expandableRowsComponentProps,
      g = _ref42.expandableRowsHideExpander,
      _ref42$expandOnRowCli = _ref42.expandOnRowClicked,
      u = _ref42$expandOnRowCli === void 0 ? !1 : _ref42$expandOnRowCli,
      _ref42$expandOnRowDou = _ref42.expandOnRowDoubleClicked,
      p = _ref42$expandOnRowDou === void 0 ? !1 : _ref42$expandOnRowDou,
      _ref42$highlightOnHov = _ref42.highlightOnHover,
      b = _ref42$highlightOnHov === void 0 ? !1 : _ref42$highlightOnHov,
      h = _ref42.id,
      w = _ref42.expandableInheritConditionalStyles,
      C = _ref42.keyField,
      _ref42$onRowClicked = _ref42.onRowClicked,
      y = _ref42$onRowClicked === void 0 ? f : _ref42$onRowClicked,
      _ref42$onRowDoubleCli = _ref42.onRowDoubleClicked,
      v = _ref42$onRowDoubleCli === void 0 ? f : _ref42$onRowDoubleCli,
      _ref42$onRowExpandTog = _ref42.onRowExpandToggled,
      R = _ref42$onRowExpandTog === void 0 ? f : _ref42$onRowExpandTog,
      _ref42$onSelectedRow = _ref42.onSelectedRow,
      S = _ref42$onSelectedRow === void 0 ? f : _ref42$onSelectedRow,
      _ref42$pointerOnHover = _ref42.pointerOnHover,
      E = _ref42$pointerOnHover === void 0 ? !1 : _ref42$pointerOnHover,
      O = _ref42.row,
      P = _ref42.rowCount,
      k = _ref42.rowIndex,
      _ref42$selectableRowD = _ref42.selectableRowDisabled,
      D = _ref42$selectableRowD === void 0 ? null : _ref42$selectableRowD,
      _ref42$selectableRows = _ref42.selectableRows,
      H = _ref42$selectableRows === void 0 ? !1 : _ref42$selectableRows,
      $ = _ref42.selectableRowsComponent,
      j = _ref42.selectableRowsComponentProps,
      _ref42$selectableRows2 = _ref42.selectableRowsHighlight,
      F = _ref42$selectableRows2 === void 0 ? !1 : _ref42$selectableRows2,
      _ref42$selectableRows3 = _ref42.selectableRowsSingle,
      I = _ref42$selectableRows3 === void 0 ? !1 : _ref42$selectableRows3,
      A = _ref42.selected,
      _ref42$striped = _ref42.striped,
      L = _ref42$striped === void 0 ? !1 : _ref42$striped,
      M = _ref42.draggingColumnId,
      z = _ref42.onDragStart,
      W = _ref42.onDragOver,
      G = _ref42.onDragEnd,
      V = _ref42.onDragEnter,
      U = _ref42.onDragLeave;

  var _l$useState = l.useState(n),
      _l$useState2 = _slicedToArray(_l$useState, 2),
      q = _l$useState2[0],
      Y = _l$useState2[1];

  l.useEffect(function () {
    Y(n);
  }, [n]);

  var J = l.useCallback(function () {
    Y(!q), R(!q, O);
  }, [q, R, O]),
      Q = E || i && (u || p),
      X = l.useCallback(function (e) {
    e.target && "allowRowEvents" === e.target.getAttribute("data-tag") && (y(O, e), !o && i && u && J());
  }, [o, u, i, J, y, O]),
      Z = l.useCallback(function (e) {
    e.target && "allowRowEvents" === e.target.getAttribute("data-tag") && (v(O, e), !o && i && p && J());
  }, [o, p, i, J, v, O]),
      ee = s(O, C),
      _m2 = m(O, t, ["rdt_TableRow"]),
      te = _m2.style,
      ne = _m2.classNames,
      oe = F && A,
      ae = w ? te : {},
      le = L && k % 2 == 0;

  return l.createElement(l.Fragment, null, l.createElement(K, {
    id: "row-".concat(h),
    role: "row",
    striped: le,
    highlightOnHover: b,
    pointerOnHover: !o && Q,
    dense: a,
    onClick: X,
    onDoubleClick: Z,
    className: ne,
    selected: oe,
    style: te
  }, H && l.createElement(_, {
    name: "select-row-".concat(ee),
    keyField: C,
    row: O,
    rowCount: P,
    selected: A,
    selectableRowsComponent: $,
    selectableRowsComponentProps: j,
    selectableRowDisabled: D,
    selectableRowsSingle: I,
    onSelectedRow: S
  }), i && !g && l.createElement(N, {
    id: ee,
    expandableIcon: r,
    expanded: q,
    row: O,
    onToggled: J,
    disabled: o
  }), e.map(function (e) {
    return e.omit ? null : l.createElement(T, {
      id: "cell-".concat(e.id, "-").concat(ee),
      key: "cell-".concat(e.id, "-").concat(ee),
      dataTag: e.ignoreRowClick || e.button ? null : "allowRowEvents",
      column: e,
      row: O,
      rowIndex: k,
      isDragging: x(M, e.id),
      onDragStart: z,
      onDragOver: W,
      onDragEnd: G,
      onDragEnter: V,
      onDragLeave: U
    });
  })), i && q && l.createElement(B, {
    key: "expander-".concat(ee),
    data: O,
    extendedRowStyle: ae,
    extendedClassNames: ne,
    ExpanderComponent: d,
    expanderComponentProps: c
  }));
}

var Q = i.default.span(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n\tpadding: 2px;\n\tcolor: inherit;\n\tflex-grow: 0;\n\tflex-shrink: 0;\n\t", ";\n\t", ";\n"])), function (_ref43) {
  var e = _ref43.sortActive;
  return e ? "opacity: 1" : "opacity: 0";
}, function (_ref44) {
  var e = _ref44.sortDirection;
  return "desc" === e && "transform: rotate(180deg)";
}),
    X = function X(_ref45) {
  var e = _ref45.sortActive,
      t = _ref45.sortDirection;
  return r.default.createElement(Q, {
    sortActive: e,
    sortDirection: t
  }, "▲");
},
    Z = i.default($)(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n\t", ";\n\t", ";\n"])), function (_ref46) {
  var e = _ref46.button;
  return e && "text-align: center";
}, function (_ref47) {
  var e = _ref47.theme,
      t = _ref47.isDragging;
  return t && e.headCells.draggingStyle;
}),
    ee = t.css(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tspan.__rdt_custom_sort_icon__ {\n\t\ti,\n\t\tsvg {\n\t\t\ttransform: 'translate3d(0, 0, 0)';\n\t\t\t", ";\n\t\t\tcolor: inherit;\n\t\t\tfont-size: 18px;\n\t\t\theight: 18px;\n\t\t\twidth: 18px;\n\t\t\tbackface-visibility: hidden;\n\t\t\ttransform-style: preserve-3d;\n\t\t\ttransition-duration: 95ms;\n\t\t\ttransition-property: transform;\n\t\t}\n\n\t\t&.asc i,\n\t\t&.asc svg {\n\t\t\ttransform: rotate(180deg);\n\t\t}\n\t}\n\n\t", ";\n"])), function (_ref48) {
  var e = _ref48.sortActive;
  return e ? "opacity: 1" : "opacity: 0";
}, function (_ref49) {
  var e = _ref49.sortActive;
  return !e && t.css(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n\t\t\t&:hover,\n\t\t\t&:focus {\n\t\t\t\topacity: 0.7;\n\n\t\t\t\tspan,\n\t\t\t\tspan.__rdt_custom_sort_icon__ * {\n\t\t\t\t\topacity: 0.7;\n\t\t\t\t}\n\t\t\t}\n\t\t"])));
}),
    te = i.default.div(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: inherit;\n\theight: 100%;\n\twidth: 100%;\n\toutline: none;\n\tuser-select: none;\n\toverflow: hidden;\n\t", ";\n"])), function (_ref50) {
  var e = _ref50.disabled;
  return !e && ee;
}),
    ne = i.default.div(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n"])));

var oe = l.memo(function (_ref51) {
  var e = _ref51.column,
      t = _ref51.disabled,
      n = _ref51.draggingColumnId,
      _ref51$selectedColumn = _ref51.selectedColumn,
      o = _ref51$selectedColumn === void 0 ? {} : _ref51$selectedColumn,
      r = _ref51.sortDirection,
      i = _ref51.sortIcon,
      s = _ref51.sortServer,
      d = _ref51.pagination,
      c = _ref51.paginationServer,
      g = _ref51.persistSelectedOnSort,
      u = _ref51.selectableRowsVisibleOnly,
      p = _ref51.onSort,
      b = _ref51.onDragStart,
      f = _ref51.onDragOver,
      m = _ref51.onDragEnd,
      h = _ref51.onDragEnter,
      w = _ref51.onDragLeave;
  l.useEffect(function () {
    "string" == typeof e.selector && console.error("Warning: ".concat(e.selector, " is a string based column selector which has been deprecated as of v7 and will be removed in v8. Instead, use a selector function e.g. row => row[field]..."));
  }, []);

  var _l$useState3 = l.useState(!1),
      _l$useState4 = _slicedToArray(_l$useState3, 2),
      C = _l$useState4[0],
      y = _l$useState4[1],
      v = l.useRef(null);

  if (l.useEffect(function () {
    v.current && y(v.current.scrollWidth > v.current.clientWidth);
  }, [C]), e.omit) return null;

  var R = function R() {
    if (!e.sortable && !e.selector) return;
    var t = r;
    x(o.id, e.id) && (t = r === a.ASC ? a.DESC : a.ASC), p({
      type: "SORT_CHANGE",
      sortDirection: t,
      selectedColumn: e,
      clearSelectedOnSort: d && c && !g || s || u
    });
  },
      S = function S(e) {
    return l.createElement(X, {
      sortActive: e,
      sortDirection: r
    });
  },
      E = function E() {
    return l.createElement("span", {
      className: [r, "__rdt_custom_sort_icon__"].join(" ")
    }, i);
  },
      O = !(!e.sortable || !x(o.id, e.id)),
      P = !e.sortable || t,
      k = e.sortable && !i && !e.right,
      D = e.sortable && !i && e.right,
      H = e.sortable && i && !e.right,
      $ = e.sortable && i && e.right;

  return l.createElement(Z, {
    "data-column-id": e.id,
    className: "rdt_TableCol",
    headCell: !0,
    allowOverflow: e.allowOverflow,
    button: e.button,
    compact: e.compact,
    grow: e.grow,
    hide: e.hide,
    maxWidth: e.maxWidth,
    minWidth: e.minWidth,
    right: e.right,
    center: e.center,
    width: e.width,
    draggable: e.reorder,
    isDragging: x(e.id, n),
    onDragStart: b,
    onDragOver: f,
    onDragEnd: m,
    onDragEnter: h,
    onDragLeave: w
  }, e.name && l.createElement(te, {
    "data-column-id": e.id,
    "data-sort-id": e.id,
    role: "columnheader",
    tabIndex: 0,
    className: "rdt_TableCol_Sortable",
    onClick: P ? void 0 : R,
    onKeyPress: P ? void 0 : function (e) {
      "Enter" === e.key && R();
    },
    sortActive: !P && O,
    disabled: P
  }, !P && $ && E(), !P && D && S(O), "string" == typeof e.name ? l.createElement(ne, {
    title: C ? e.name : void 0,
    ref: v,
    "data-column-id": e.id
  }, e.name) : e.name, !P && H && E(), !P && k && S(O)));
});
var ae = i.default(H)(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n\tflex: 0 0 48px;\n\tjustify-content: center;\n\talign-items: center;\n\tuser-select: none;\n\twhite-space: nowrap;\n\tfont-size: unset;\n"])));

function le(_ref52) {
  var _ref52$headCell = _ref52.headCell,
      e = _ref52$headCell === void 0 ? !0 : _ref52$headCell,
      t = _ref52.rowData,
      n = _ref52.keyField,
      o = _ref52.allSelected,
      a = _ref52.mergeSelections,
      r = _ref52.selectedRows,
      i = _ref52.selectableRowsComponent,
      s = _ref52.selectableRowsComponentProps,
      d = _ref52.selectableRowDisabled,
      c = _ref52.onSelectAllRows;
  var g = r.length > 0 && !o,
      u = d ? t.filter(function (e) {
    return !d(e);
  }) : t,
      p = 0 === u.length,
      b = Math.min(t.length, u.length);
  return l.createElement(ae, {
    className: "rdt_TableCol",
    headCell: e,
    noPadding: !0
  }, l.createElement(I, {
    name: "select-all-rows",
    component: i,
    componentOptions: s,
    onClick: function onClick() {
      c({
        type: "SELECT_ALL_ROWS",
        rows: u,
        rowCount: b,
        mergeSelections: a,
        keyField: n
      });
    },
    checked: o,
    indeterminate: g,
    disabled: p
  }));
}

function re() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : exports.Direction.AUTO;

  var t = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)),
      _l$useState5 = l.useState(!1),
      _l$useState6 = _slicedToArray(_l$useState5, 2),
      n = _l$useState6[0],
      o = _l$useState6[1];

  return l.useEffect(function () {
    if (t) if ("auto" !== e) o("rtl" === e);else {
      var _e2 = !(!window.document || !window.document.createElement),
          _t4 = document.getElementsByTagName("BODY")[0],
          _n4 = document.getElementsByTagName("HTML")[0],
          _a6 = "rtl" === _t4.dir || "rtl" === _n4.dir;

      o(_e2 && _a6);
    }
  }, [e, t]), n;
}

var ie = i.default.div(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tflex: 1 0 auto;\n\theight: 100%;\n\tcolor: ", ";\n\tfont-size: ", ";\n\tfont-weight: 400;\n"])), function (_ref53) {
  var e = _ref53.theme;
  return e.contextMenu.fontColor;
}, function (_ref54) {
  var e = _ref54.theme;
  return e.contextMenu.fontSize;
}),
    se = i.default.div(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tflex-wrap: wrap;\n"]))),
    de = i.default.div(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbox-sizing: inherit;\n\tz-index: 1;\n\talign-items: center;\n\tjustify-content: space-between;\n\tdisplay: flex;\n\t", ";\n\t", ";\n\t", ";\n"])), function (_ref55) {
  var e = _ref55.rtl;
  return e && "direction: rtl";
}, function (_ref56) {
  var e = _ref56.theme;
  return e.contextMenu.style;
}, function (_ref57) {
  var e = _ref57.theme,
      t = _ref57.visible;
  return t && e.contextMenu.activeStyle;
});

function ce(_ref58) {
  var e = _ref58.contextMessage,
      t = _ref58.contextActions,
      n = _ref58.contextComponent,
      o = _ref58.selectedCount,
      a = _ref58.direction;
  var r = re(a),
      i = o > 0;
  return n ? l.createElement(de, {
    visible: i
  }, l.cloneElement(n, {
    selectedCount: o
  })) : l.createElement(de, {
    visible: i,
    rtl: r
  }, l.createElement(ie, null, function (e, t, n) {
    if (0 === t) return null;
    var o = 1 === t ? e.singular : e.plural;
    return n ? "".concat(t, " ").concat(e.message || "", " ").concat(o) : "".concat(t, " ").concat(o, " ").concat(e.message || "");
  }(e, o, r)), l.createElement(se, null, t));
}

var ge = i.default.div(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n\tposition: relative;\n\tbox-sizing: border-box;\n\toverflow: hidden;\n\tdisplay: flex;\n\tflex: 1 1 auto;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 100%;\n\tflex-wrap: wrap;\n\t", "\n"])), function (_ref59) {
  var e = _ref59.theme;
  return e.header.style;
}),
    ue = i.default.div(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n\tflex: 1 0 auto;\n\tcolor: ", ";\n\tfont-size: ", ";\n\tfont-weight: 400;\n"])), function (_ref60) {
  var e = _ref60.theme;
  return e.header.fontColor;
}, function (_ref61) {
  var e = _ref61.theme;
  return e.header.fontSize;
}),
    pe = i.default.div(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n\tflex: 1 0 auto;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\n\t> * {\n\t\tmargin-left: 5px;\n\t}\n"]))),
    be = function be(_ref62) {
  var e = _ref62.title,
      _ref62$actions = _ref62.actions,
      t = _ref62$actions === void 0 ? null : _ref62$actions,
      n = _ref62.contextMessage,
      o = _ref62.contextActions,
      a = _ref62.contextComponent,
      r = _ref62.selectedCount,
      i = _ref62.direction,
      _ref62$showMenu = _ref62.showMenu,
      s = _ref62$showMenu === void 0 ? !0 : _ref62$showMenu;
  return l.createElement(ge, {
    className: "rdt_TableHeader",
    role: "heading",
    "aria-level": 1
  }, l.createElement(ue, null, e), t && l.createElement(pe, null, t), s && l.createElement(ce, {
    contextMessage: n,
    contextActions: o,
    contextComponent: a,
    direction: i,
    selectedCount: r
  }));
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
;

function fe(e, t) {
  var n = {};

  for (var o in e) {
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var a = 0;

    for (o = Object.getOwnPropertySymbols(e); a < o.length; a++) {
      t.indexOf(o[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[a]) && (n[o[a]] = e[o[a]]);
    }
  }

  return n;
}

var me = {
  left: "flex-start",
  right: "flex-end",
  center: "center"
},
    he = i.default.header(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n\tposition: relative;\n\tdisplay: flex;\n\tflex: 1 1 auto;\n\tbox-sizing: border-box;\n\talign-items: center;\n\tpadding: 4px 16px 4px 24px;\n\twidth: 100%;\n\tjustify-content: ", ";\n\tflex-wrap: ", ";\n\t", "\n"])), function (_ref63) {
  var e = _ref63.align;
  return me[e];
}, function (_ref64) {
  var e = _ref64.wrapContent;
  return e ? "wrap" : "nowrap";
}, function (_ref65) {
  var e = _ref65.theme;
  return e.subHeader.style;
}),
    we = function we(e) {
  var _e$align = e.align,
      t = _e$align === void 0 ? "right" : _e$align,
      _e$wrapContent = e.wrapContent,
      n = _e$wrapContent === void 0 ? !0 : _e$wrapContent,
      o = fe(e, ["align", "wrapContent"]);
  return l.createElement(he, Object.assign({
    align: t,
    wrapContent: n
  }, o));
},
    xe = i.default.div(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-direction: column;\n"]))),
    Ce = i.default.div(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n\tposition: relative;\n\twidth: 100%;\n\tborder-radius: inherit;\n\t", ";\n\n\t", ";\n"])), function (_ref66) {
  var e = _ref66.responsive,
      n = _ref66.fixedHeader;
  return e && t.css(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n\t\t\toverflow-x: auto;\n\n\t\t\t// hidden prevents vertical scrolling in firefox when fixedHeader is disabled\n\t\t\toverflow-y: ", ";\n\t\t\tmin-height: 0;\n\t\t"])), n ? "auto" : "hidden");
}, function (_ref67) {
  var _ref67$fixedHeader = _ref67.fixedHeader,
      e = _ref67$fixedHeader === void 0 ? !1 : _ref67$fixedHeader,
      _ref67$fixedHeaderScr = _ref67.fixedHeaderScrollHeight,
      n = _ref67$fixedHeaderScr === void 0 ? "100vh" : _ref67$fixedHeaderScr;
  return e && t.css(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n\t\t\tmax-height: ", ";\n\t\t\t-webkit-overflow-scrolling: touch;\n\t\t"])), n);
}),
    ye = i.default.div(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n\tposition: relative;\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: 100%;\n\t", ";\n"])), function (e) {
  return e.theme.progress.style;
}),
    ve = i.default.div(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n\tposition: relative;\n\twidth: 100%;\n\t", ";\n"])), function (_ref68) {
  var e = _ref68.theme;
  return e.tableWrapper.style;
}),
    Re = i.default(H)(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n\twhite-space: nowrap;\n\t", ";\n"])), function (_ref69) {
  var e = _ref69.theme;
  return e.expanderCell.style;
}),
    Se = i.default.div(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: 100%;\n\t", ";\n"])), function (_ref70) {
  var e = _ref70.theme;
  return e.noData.style;
}),
    Ee = function Ee() {
  return r.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, r.default.createElement("path", {
    d: "M7 10l5 5 5-5z"
  }), r.default.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
},
    Oe = i.default.select(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\theight: 24px;\n\tmax-width: 100%;\n\tuser-select: none;\n\tpadding-left: 8px;\n\tpadding-right: 24px;\n\tbox-sizing: content-box;\n\tfont-size: inherit;\n\tcolor: inherit;\n\tborder: none;\n\tbackground-color: transparent;\n\tappearance: none;\n\tdirection: ltr;\n\tflex-shrink: 0;\n\n\t&::-ms-expand {\n\t\tdisplay: none;\n\t}\n\n\t&:disabled::-ms-expand {\n\t\tbackground: #f60;\n\t}\n\n\toption {\n\t\tcolor: initial;\n\t}\n"]))),
    Pe = i.default.div(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n\tposition: relative;\n\tflex-shrink: 0;\n\tfont-size: inherit;\n\tcolor: inherit;\n\tmargin-top: 1px;\n\n\tsvg {\n\t\ttop: 0;\n\t\tright: 0;\n\t\tcolor: inherit;\n\t\tposition: absolute;\n\t\tfill: currentColor;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tdisplay: inline-block;\n\t\tuser-select: none;\n\t\tpointer-events: none;\n\t}\n"]))),
    ke = function ke(e) {
  var t = e.defaultValue,
      n = e.onChange,
      o = fe(e, ["defaultValue", "onChange"]);
  return l.createElement(Pe, null, l.createElement(Oe, Object.assign({
    onChange: n,
    defaultValue: t
  }, o)), l.createElement(Ee, null));
},
    De = {
  columns: [],
  data: [],
  title: "",
  keyField: "id",
  selectableRows: !1,
  selectableRowsHighlight: !1,
  selectableRowsNoSelectAll: !1,
  selectableRowSelected: null,
  selectableRowDisabled: null,
  selectableRowsComponent: "input",
  selectableRowsComponentProps: {},
  selectableRowsVisibleOnly: !1,
  selectableRowsSingle: !1,
  clearSelectedRows: !1,
  expandableRows: !1,
  expandableRowDisabled: null,
  expandableRowExpanded: null,
  expandOnRowClicked: !1,
  expandableRowsHideExpander: !1,
  expandOnRowDoubleClicked: !1,
  expandableInheritConditionalStyles: !1,
  expandableRowsComponent: function expandableRowsComponent() {
    return r.default.createElement("div", null, "To add an expander pass in a component instance via ", r.default.createElement("strong", null, "expandableRowsComponent"), ". You can then access props.data from this component.");
  },
  expandableIcon: {
    collapsed: r.default.createElement(function () {
      return r.default.createElement("svg", {
        fill: "currentColor",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg"
      }, r.default.createElement("path", {
        d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
      }), r.default.createElement("path", {
        d: "M0-.25h24v24H0z",
        fill: "none"
      }));
    }, null),
    expanded: r.default.createElement(function () {
      return r.default.createElement("svg", {
        fill: "currentColor",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg"
      }, r.default.createElement("path", {
        d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
      }), r.default.createElement("path", {
        d: "M0-.75h24v24H0z",
        fill: "none"
      }));
    }, null)
  },
  expandableRowsComponentProps: {},
  progressPending: !1,
  progressComponent: r.default.createElement("div", {
    style: {
      fontSize: "24px",
      fontWeight: 700,
      padding: "24px"
    }
  }, "Loading..."),
  persistTableHead: !1,
  sortIcon: null,
  sortFunction: null,
  sortServer: !1,
  striped: !1,
  highlightOnHover: !1,
  pointerOnHover: !1,
  noContextMenu: !1,
  contextMessage: {
    singular: "item",
    plural: "items",
    message: "selected"
  },
  actions: null,
  contextActions: null,
  contextComponent: null,
  defaultSortFieldId: null,
  defaultSortAsc: !0,
  responsive: !0,
  noDataComponent: r.default.createElement("div", {
    style: {
      padding: "24px"
    }
  }, "There are no records to display"),
  disabled: !1,
  noTableHead: !1,
  noHeader: !1,
  subHeader: !1,
  subHeaderAlign: exports.Alignment.RIGHT,
  subHeaderWrap: !0,
  subHeaderComponent: null,
  fixedHeader: !1,
  fixedHeaderScrollHeight: "100vh",
  pagination: !1,
  paginationServer: !1,
  paginationServerOptions: {
    persistSelectedOnSort: !1,
    persistSelectedOnPageChange: !1
  },
  paginationDefaultPage: 1,
  paginationResetDefaultPage: !1,
  paginationTotalRows: 0,
  paginationPerPage: 10,
  paginationRowsPerPageOptions: [10, 15, 20, 25, 30],
  paginationComponent: null,
  paginationComponentOptions: {},
  paginationIconFirstPage: r.default.createElement(function () {
    return r.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "aria-hidden": "true",
      role: "presentation"
    }, r.default.createElement("path", {
      d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
    }), r.default.createElement("path", {
      fill: "none",
      d: "M24 24H0V0h24v24z"
    }));
  }, null),
  paginationIconLastPage: r.default.createElement(function () {
    return r.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "aria-hidden": "true",
      role: "presentation"
    }, r.default.createElement("path", {
      d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
    }), r.default.createElement("path", {
      fill: "none",
      d: "M0 0h24v24H0V0z"
    }));
  }, null),
  paginationIconNext: r.default.createElement(function () {
    return r.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "aria-hidden": "true",
      role: "presentation"
    }, r.default.createElement("path", {
      d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
    }), r.default.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }));
  }, null),
  paginationIconPrevious: r.default.createElement(function () {
    return r.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "aria-hidden": "true",
      role: "presentation"
    }, r.default.createElement("path", {
      d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }), r.default.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }));
  }, null),
  dense: !1,
  conditionalRowStyles: [],
  theme: "default",
  customStyles: {},
  direction: exports.Direction.AUTO,
  onChangePage: f,
  onChangeRowsPerPage: f,
  onRowClicked: f,
  onRowDoubleClicked: f,
  onRowExpandToggled: f,
  onSelectedRowsChange: f,
  onSort: f,
  onColumnOrderChange: f
},
    He = {
  rowsPerPageText: "Rows per page:",
  rangeSeparatorText: "of",
  noRowsPerPage: !1,
  selectAllRowsItem: !1,
  selectAllRowsItemText: "All"
},
    $e = i.default.nav(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex: 1 1 auto;\n\tjustify-content: flex-end;\n\talign-items: center;\n\tbox-sizing: border-box;\n\tpadding-right: 8px;\n\tpadding-left: 8px;\n\twidth: 100%;\n\t", ";\n"])), function (_ref71) {
  var e = _ref71.theme;
  return e.pagination.style;
}),
    je = i.default.button(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n\tposition: relative;\n\tdisplay: block;\n\tuser-select: none;\n\tborder: none;\n\t", ";\n\t", ";\n"])), function (_ref72) {
  var e = _ref72.theme;
  return e.pagination.pageButtonsStyle;
}, function (_ref73) {
  var e = _ref73.isRTL;
  return e && "transform: scale(-1, -1)";
}),
    Fe = i.default.div(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tborder-radius: 4px;\n\twhite-space: nowrap;\n\t", ";\n"])), O(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n    width: 100%;\n    justify-content: space-around;\n  "])))),
    Te = i.default.span(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n\tflex-shrink: 1;\n\tuser-select: none;\n"]))),
    Ie = i.default(Te)(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n\tmargin: 0 24px;\n"]))),
    Ae = i.default(Te)(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n\tmargin: 0 4px;\n"])));

var _e = l.memo(function (_ref74) {
  var e = _ref74.rowsPerPage,
      t = _ref74.rowCount,
      n = _ref74.currentPage,
      _ref74$direction = _ref74.direction,
      o = _ref74$direction === void 0 ? De.direction : _ref74$direction,
      _ref74$paginationRows = _ref74.paginationRowsPerPageOptions,
      a = _ref74$paginationRows === void 0 ? De.paginationRowsPerPageOptions : _ref74$paginationRows,
      _ref74$paginationIcon = _ref74.paginationIconLastPage,
      r = _ref74$paginationIcon === void 0 ? De.paginationIconLastPage : _ref74$paginationIcon,
      _ref74$paginationIcon2 = _ref74.paginationIconFirstPage,
      i = _ref74$paginationIcon2 === void 0 ? De.paginationIconFirstPage : _ref74$paginationIcon2,
      _ref74$paginationIcon3 = _ref74.paginationIconNext,
      s = _ref74$paginationIcon3 === void 0 ? De.paginationIconNext : _ref74$paginationIcon3,
      _ref74$paginationIcon4 = _ref74.paginationIconPrevious,
      d = _ref74$paginationIcon4 === void 0 ? De.paginationIconPrevious : _ref74$paginationIcon4,
      _ref74$paginationComp = _ref74.paginationComponentOptions,
      c = _ref74$paginationComp === void 0 ? De.paginationComponentOptions : _ref74$paginationComp,
      _ref74$onChangeRowsPe = _ref74.onChangeRowsPerPage,
      g = _ref74$onChangeRowsPe === void 0 ? De.onChangeRowsPerPage : _ref74$onChangeRowsPe,
      _ref74$onChangePage = _ref74.onChangePage,
      u = _ref74$onChangePage === void 0 ? De.onChangePage : _ref74$onChangePage;

  var b = function () {
    var e = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window));

    function t() {
      return {
        width: e ? window.innerWidth : void 0,
        height: e ? window.innerHeight : void 0
      };
    }

    var _l$useState7 = l.useState(t),
        _l$useState8 = _slicedToArray(_l$useState7, 2),
        n = _l$useState8[0],
        o = _l$useState8[1];

    return l.useEffect(function () {
      if (!e) return function () {
        return null;
      };

      function n() {
        o(t());
      }

      return window.addEventListener("resize", n), function () {
        return window.removeEventListener("resize", n);
      };
    }, []), n;
  }(),
      f = re(o),
      m = b.width && b.width > 599,
      h = p(t, e),
      w = n * e,
      x = w - e + 1,
      C = 1 === n,
      y = n === h,
      v = Object.assign(Object.assign({}, He), c),
      R = n === h ? "".concat(x, "-").concat(t, " ").concat(v.rangeSeparatorText, " ").concat(t) : "".concat(x, "-").concat(w, " ").concat(v.rangeSeparatorText, " ").concat(t),
      S = l.useCallback(function () {
    return u(n - 1);
  }, [n, u]),
      E = l.useCallback(function () {
    return u(n + 1);
  }, [n, u]),
      O = l.useCallback(function () {
    return u(1);
  }, [u]),
      P = l.useCallback(function () {
    return u(p(t, e));
  }, [u, t, e]),
      k = l.useCallback(function (e) {
    return g(Number(e.target.value), n);
  }, [n, g]),
      D = a.map(function (e) {
    return l.createElement("option", {
      key: e,
      value: e
    }, e);
  });

  v.selectAllRowsItem && D.push(l.createElement("option", {
    key: -1,
    value: t
  }, v.selectAllRowsItemText));
  var H = l.createElement(ke, {
    onChange: k,
    defaultValue: e,
    "aria-label": v.rowsPerPageText
  }, D);
  return l.createElement($e, {
    className: "rdt_Pagination"
  }, !v.noRowsPerPage && m && l.createElement(l.Fragment, null, l.createElement(Ae, null, v.rowsPerPageText), H), m && l.createElement(Ie, null, R), l.createElement(Fe, null, l.createElement(je, {
    id: "pagination-first-page",
    type: "button",
    "aria-label": "First Page",
    "aria-disabled": C,
    onClick: O,
    disabled: C,
    isRTL: f
  }, i), l.createElement(je, {
    id: "pagination-previous-page",
    type: "button",
    "aria-label": "Previous Page",
    "aria-disabled": C,
    onClick: S,
    disabled: C,
    isRTL: f
  }, d), !m && H, l.createElement(je, {
    id: "pagination-next-page",
    type: "button",
    "aria-label": "Next Page",
    "aria-disabled": y,
    onClick: E,
    disabled: y,
    isRTL: f
  }, s), l.createElement(je, {
    id: "pagination-last-page",
    type: "button",
    "aria-label": "Last Page",
    "aria-disabled": y,
    onClick: P,
    disabled: y,
    isRTL: f
  }, r)));
});

var Le = function Le(e, t) {
  var n = l.useRef(!0);
  l.useEffect(function () {
    n.current ? n.current = !1 : e();
  }, t);
};

var Me = function Me(e) {
  return function (e) {
    return !!e && "object" == _typeof(e);
  }(e) && !function (e) {
    var t = Object.prototype.toString.call(e);
    return "[object RegExp]" === t || "[object Date]" === t || function (e) {
      return e.$$typeof === ze;
    }(e);
  }(e);
};

var ze = "function" == typeof Symbol && Symbol.for ? Symbol.for("react.element") : 60103;

function Ne(e, t) {
  return !1 !== t.clone && t.isMergeableObject(e) ? Ue((n = e, Array.isArray(n) ? [] : {}), e, t) : e;
  var n;
}

function We(e, t, n) {
  return e.concat(t).map(function (e) {
    return Ne(e, n);
  });
}

function Be(e) {
  return Object.keys(e).concat(function (e) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function (t) {
      return e.propertyIsEnumerable(t);
    }) : [];
  }(e));
}

function Ge(e, t) {
  try {
    return t in e;
  } catch (e) {
    return !1;
  }
}

function Ve(e, t, n) {
  var o = {};
  return n.isMergeableObject(e) && Be(e).forEach(function (t) {
    o[t] = Ne(e[t], n);
  }), Be(t).forEach(function (a) {
    (function (e, t) {
      return Ge(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
    })(e, a) || (Ge(e, a) && n.isMergeableObject(t[a]) ? o[a] = function (e, t) {
      if (!t.customMerge) return Ue;
      var n = t.customMerge(e);
      return "function" == typeof n ? n : Ue;
    }(a, n)(e[a], t[a], n) : o[a] = Ne(t[a], n));
  }), o;
}

function Ue(e, t, n) {
  (n = n || {}).arrayMerge = n.arrayMerge || We, n.isMergeableObject = n.isMergeableObject || Me, n.cloneUnlessOtherwiseSpecified = Ne;
  var o = Array.isArray(t);
  return o === Array.isArray(e) ? o ? n.arrayMerge(e, t, n) : Ve(e, t, n) : Ne(t, n);
}

Ue.all = function (e, t) {
  if (!Array.isArray(e)) throw new Error("first argument should be an array");
  return e.reduce(function (e, n) {
    return Ue(e, n, t);
  }, {});
};

var qe = Ue;
var Ye = {
  text: {
    primary: "rgba(0, 0, 0, 0.87)",
    secondary: "rgba(0, 0, 0, 0.54)",
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  background: {
    default: "#FFFFFF"
  },
  context: {
    background: "#e3f2fd",
    text: "rgba(0, 0, 0, 0.87)"
  },
  divider: {
    default: "rgba(0,0,0,.12)"
  },
  button: {
    default: "rgba(0,0,0,.54)",
    focus: "rgba(0,0,0,.12)",
    hover: "rgba(0,0,0,.12)",
    disabled: "rgba(0, 0, 0, .18)"
  },
  selected: {
    default: "#e3f2fd",
    text: "rgba(0, 0, 0, 0.87)"
  },
  highlightOnHover: {
    default: "#EEEEEE",
    text: "rgba(0, 0, 0, 0.87)"
  },
  striped: {
    default: "#FAFAFA",
    text: "rgba(0, 0, 0, 0.87)"
  }
},
    Ke = {
  default: Ye,
  light: Ye,
  dark: {
    text: {
      primary: "#FFFFFF",
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(0,0,0,.12)"
    },
    background: {
      default: "#424242"
    },
    context: {
      background: "#E91E63",
      text: "#FFFFFF"
    },
    divider: {
      default: "rgba(81, 81, 81, 1)"
    },
    button: {
      default: "#FFFFFF",
      focus: "rgba(255, 255, 255, .54)",
      hover: "rgba(255, 255, 255, .12)",
      disabled: "rgba(255, 255, 255, .18)"
    },
    selected: {
      default: "rgba(0, 0, 0, .7)",
      text: "#FFFFFF"
    },
    highlightOnHover: {
      default: "rgba(0, 0, 0, .7)",
      text: "#FFFFFF"
    },
    striped: {
      default: "rgba(0, 0, 0, .87)",
      text: "#FFFFFF"
    }
  }
};

function Je(e, t, n, o) {
  var _l$useState9 = l.useState(function () {
    return u(e);
  }),
      _l$useState10 = _slicedToArray(_l$useState9, 2),
      r = _l$useState10[0],
      i = _l$useState10[1],
      _l$useState11 = l.useState(""),
      _l$useState12 = _slicedToArray(_l$useState11, 2),
      s = _l$useState12[0],
      d = _l$useState12[1],
      c = l.useRef("");

  Le(function () {
    i(u(e));
  }, [e]);

  var g = l.useCallback(function (e) {
    var t, n, o;
    var a = e.target.attributes,
        l = null === (t = a.getNamedItem("data-column-id")) || void 0 === t ? void 0 : t.value;
    l && (c.current = (null === (o = null === (n = r[w(r, l)]) || void 0 === n ? void 0 : n.id) || void 0 === o ? void 0 : o.toString()) || "", d(c.current));
  }, [r]),
      p = l.useCallback(function (e) {
    var n;
    var o = e.target.attributes,
        a = null === (n = o.getNamedItem("data-column-id")) || void 0 === n ? void 0 : n.value;

    if (a && c.current && a !== c.current) {
      var _e3 = w(r, c.current),
          _n5 = w(r, a),
          _o7 = _toConsumableArray(r);

      _o7[_e3] = r[_n5], _o7[_n5] = r[_e3], i(_o7), t(_o7);
    }
  }, [t, r]),
      b = l.useCallback(function (e) {
    e.preventDefault();
  }, []),
      f = l.useCallback(function (e) {
    e.preventDefault();
  }, []),
      m = l.useCallback(function (e) {
    e.preventDefault(), c.current = "", d("");
  }, []),
      h = function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    return e ? a.ASC : a.DESC;
  }(o),
      x = l.useMemo(function () {
    return r[w(r, null == n ? void 0 : n.toString())] || {};
  }, [n, r]);

  return {
    tableColumns: r,
    draggingColumnId: s,
    handleDragStart: g,
    handleDragEnter: p,
    handleDragOver: b,
    handleDragLeave: f,
    handleDragEnd: m,
    defaultSortDirection: h,
    defaultSortColumn: x
  };
}

var Qe = l.memo(function (e) {
  var _e$data = e.data,
      n = _e$data === void 0 ? De.data : _e$data,
      _e$columns = e.columns,
      o = _e$columns === void 0 ? De.columns : _e$columns,
      _e$title = e.title,
      r = _e$title === void 0 ? De.title : _e$title,
      _e$actions = e.actions,
      i = _e$actions === void 0 ? De.actions : _e$actions,
      _e$keyField = e.keyField,
      c = _e$keyField === void 0 ? De.keyField : _e$keyField,
      _e$striped = e.striped,
      g = _e$striped === void 0 ? De.striped : _e$striped,
      _e$highlightOnHover = e.highlightOnHover,
      u = _e$highlightOnHover === void 0 ? De.highlightOnHover : _e$highlightOnHover,
      _e$pointerOnHover = e.pointerOnHover,
      f = _e$pointerOnHover === void 0 ? De.pointerOnHover : _e$pointerOnHover,
      _e$dense = e.dense,
      m = _e$dense === void 0 ? De.dense : _e$dense,
      _e$selectableRows = e.selectableRows,
      w = _e$selectableRows === void 0 ? De.selectableRows : _e$selectableRows,
      _e$selectableRowsSing = e.selectableRowsSingle,
      x = _e$selectableRowsSing === void 0 ? De.selectableRowsSingle : _e$selectableRowsSing,
      _e$selectableRowsHigh = e.selectableRowsHighlight,
      y = _e$selectableRowsHigh === void 0 ? De.selectableRowsHighlight : _e$selectableRowsHigh,
      _e$selectableRowsNoSe = e.selectableRowsNoSelectAll,
      R = _e$selectableRowsNoSe === void 0 ? De.selectableRowsNoSelectAll : _e$selectableRowsNoSe,
      _e$selectableRowsVisi = e.selectableRowsVisibleOnly,
      O = _e$selectableRowsVisi === void 0 ? De.selectableRowsVisibleOnly : _e$selectableRowsVisi,
      _e$selectableRowSelec = e.selectableRowSelected,
      P = _e$selectableRowSelec === void 0 ? De.selectableRowSelected : _e$selectableRowSelec,
      _e$selectableRowDisab = e.selectableRowDisabled,
      k = _e$selectableRowDisab === void 0 ? De.selectableRowDisabled : _e$selectableRowDisab,
      _e$selectableRowsComp = e.selectableRowsComponent,
      D = _e$selectableRowsComp === void 0 ? De.selectableRowsComponent : _e$selectableRowsComp,
      _e$selectableRowsComp2 = e.selectableRowsComponentProps,
      $ = _e$selectableRowsComp2 === void 0 ? De.selectableRowsComponentProps : _e$selectableRowsComp2,
      _e$onRowExpandToggled = e.onRowExpandToggled,
      j = _e$onRowExpandToggled === void 0 ? De.onRowExpandToggled : _e$onRowExpandToggled,
      _e$onSelectedRowsChan = e.onSelectedRowsChange,
      F = _e$onSelectedRowsChan === void 0 ? De.onSelectedRowsChange : _e$onSelectedRowsChan,
      _e$expandableIcon = e.expandableIcon,
      T = _e$expandableIcon === void 0 ? De.expandableIcon : _e$expandableIcon,
      _e$onChangeRowsPerPag = e.onChangeRowsPerPage,
      I = _e$onChangeRowsPerPag === void 0 ? De.onChangeRowsPerPage : _e$onChangeRowsPerPag,
      _e$onChangePage = e.onChangePage,
      A = _e$onChangePage === void 0 ? De.onChangePage : _e$onChangePage,
      _e$paginationServer = e.paginationServer,
      _ = _e$paginationServer === void 0 ? De.paginationServer : _e$paginationServer,
      _e$paginationServerOp = e.paginationServerOptions,
      L = _e$paginationServerOp === void 0 ? De.paginationServerOptions : _e$paginationServerOp,
      _e$paginationTotalRow = e.paginationTotalRows,
      M = _e$paginationTotalRow === void 0 ? De.paginationTotalRows : _e$paginationTotalRow,
      _e$paginationDefaultP = e.paginationDefaultPage,
      z = _e$paginationDefaultP === void 0 ? De.paginationDefaultPage : _e$paginationDefaultP,
      _e$paginationResetDef = e.paginationResetDefaultPage,
      N = _e$paginationResetDef === void 0 ? De.paginationResetDefaultPage : _e$paginationResetDef,
      _e$paginationPerPage = e.paginationPerPage,
      W = _e$paginationPerPage === void 0 ? De.paginationPerPage : _e$paginationPerPage,
      _e$paginationRowsPerP = e.paginationRowsPerPageOptions,
      B = _e$paginationRowsPerP === void 0 ? De.paginationRowsPerPageOptions : _e$paginationRowsPerP,
      _e$paginationIconLast = e.paginationIconLastPage,
      G = _e$paginationIconLast === void 0 ? De.paginationIconLastPage : _e$paginationIconLast,
      _e$paginationIconFirs = e.paginationIconFirstPage,
      V = _e$paginationIconFirs === void 0 ? De.paginationIconFirstPage : _e$paginationIconFirs,
      _e$paginationIconNext = e.paginationIconNext,
      U = _e$paginationIconNext === void 0 ? De.paginationIconNext : _e$paginationIconNext,
      _e$paginationIconPrev = e.paginationIconPrevious,
      q = _e$paginationIconPrev === void 0 ? De.paginationIconPrevious : _e$paginationIconPrev,
      _e$paginationComponen = e.paginationComponent,
      Y = _e$paginationComponen === void 0 ? De.paginationComponent : _e$paginationComponen,
      _e$paginationComponen2 = e.paginationComponentOptions,
      K = _e$paginationComponen2 === void 0 ? De.paginationComponentOptions : _e$paginationComponen2,
      _e$responsive = e.responsive,
      Q = _e$responsive === void 0 ? De.responsive : _e$responsive,
      _e$progressPending = e.progressPending,
      X = _e$progressPending === void 0 ? De.progressPending : _e$progressPending,
      _e$progressComponent = e.progressComponent,
      Z = _e$progressComponent === void 0 ? De.progressComponent : _e$progressComponent,
      _e$persistTableHead = e.persistTableHead,
      ee = _e$persistTableHead === void 0 ? De.persistTableHead : _e$persistTableHead,
      _e$noDataComponent = e.noDataComponent,
      te = _e$noDataComponent === void 0 ? De.noDataComponent : _e$noDataComponent,
      _e$disabled = e.disabled,
      ne = _e$disabled === void 0 ? De.disabled : _e$disabled,
      _e$noTableHead = e.noTableHead,
      ae = _e$noTableHead === void 0 ? De.noTableHead : _e$noTableHead,
      _e$noHeader = e.noHeader,
      re = _e$noHeader === void 0 ? De.noHeader : _e$noHeader,
      _e$fixedHeader = e.fixedHeader,
      ie = _e$fixedHeader === void 0 ? De.fixedHeader : _e$fixedHeader,
      _e$fixedHeaderScrollH = e.fixedHeaderScrollHeight,
      se = _e$fixedHeaderScrollH === void 0 ? De.fixedHeaderScrollHeight : _e$fixedHeaderScrollH,
      _e$pagination = e.pagination,
      de = _e$pagination === void 0 ? De.pagination : _e$pagination,
      _e$subHeader = e.subHeader,
      ce = _e$subHeader === void 0 ? De.subHeader : _e$subHeader,
      _e$subHeaderAlign = e.subHeaderAlign,
      ge = _e$subHeaderAlign === void 0 ? De.subHeaderAlign : _e$subHeaderAlign,
      _e$subHeaderWrap = e.subHeaderWrap,
      ue = _e$subHeaderWrap === void 0 ? De.subHeaderWrap : _e$subHeaderWrap,
      _e$subHeaderComponent = e.subHeaderComponent,
      pe = _e$subHeaderComponent === void 0 ? De.subHeaderComponent : _e$subHeaderComponent,
      _e$noContextMenu = e.noContextMenu,
      fe = _e$noContextMenu === void 0 ? De.noContextMenu : _e$noContextMenu,
      _e$contextMessage = e.contextMessage,
      me = _e$contextMessage === void 0 ? De.contextMessage : _e$contextMessage,
      _e$contextActions = e.contextActions,
      he = _e$contextActions === void 0 ? De.contextActions : _e$contextActions,
      _e$contextComponent = e.contextComponent,
      Ee = _e$contextComponent === void 0 ? De.contextComponent : _e$contextComponent,
      _e$expandableRows = e.expandableRows,
      Oe = _e$expandableRows === void 0 ? De.expandableRows : _e$expandableRows,
      _e$onRowClicked = e.onRowClicked,
      Pe = _e$onRowClicked === void 0 ? De.onRowClicked : _e$onRowClicked,
      _e$onRowDoubleClicked = e.onRowDoubleClicked,
      ke = _e$onRowDoubleClicked === void 0 ? De.onRowDoubleClicked : _e$onRowDoubleClicked,
      _e$sortIcon = e.sortIcon,
      He = _e$sortIcon === void 0 ? De.sortIcon : _e$sortIcon,
      _e$onSort = e.onSort,
      $e = _e$onSort === void 0 ? De.onSort : _e$onSort,
      _e$sortFunction = e.sortFunction,
      je = _e$sortFunction === void 0 ? De.sortFunction : _e$sortFunction,
      _e$sortServer = e.sortServer,
      Fe = _e$sortServer === void 0 ? De.sortServer : _e$sortServer,
      _e$expandableRowsComp = e.expandableRowsComponent,
      Te = _e$expandableRowsComp === void 0 ? De.expandableRowsComponent : _e$expandableRowsComp,
      _e$expandableRowsComp2 = e.expandableRowsComponentProps,
      Ie = _e$expandableRowsComp2 === void 0 ? De.expandableRowsComponentProps : _e$expandableRowsComp2,
      _e$expandableRowDisab = e.expandableRowDisabled,
      Ae = _e$expandableRowDisab === void 0 ? De.expandableRowDisabled : _e$expandableRowDisab,
      _e$expandableRowsHide = e.expandableRowsHideExpander,
      Me = _e$expandableRowsHide === void 0 ? De.expandableRowsHideExpander : _e$expandableRowsHide,
      _e$expandOnRowClicked = e.expandOnRowClicked,
      ze = _e$expandOnRowClicked === void 0 ? De.expandOnRowClicked : _e$expandOnRowClicked,
      _e$expandOnRowDoubleC = e.expandOnRowDoubleClicked,
      Ne = _e$expandOnRowDoubleC === void 0 ? De.expandOnRowDoubleClicked : _e$expandOnRowDoubleC,
      _e$expandableRowExpan = e.expandableRowExpanded,
      We = _e$expandableRowExpan === void 0 ? De.expandableRowExpanded : _e$expandableRowExpan,
      _e$expandableInheritC = e.expandableInheritConditionalStyles,
      Be = _e$expandableInheritC === void 0 ? De.expandableInheritConditionalStyles : _e$expandableInheritC,
      _e$defaultSortFieldId = e.defaultSortFieldId,
      Ge = _e$defaultSortFieldId === void 0 ? De.defaultSortFieldId : _e$defaultSortFieldId,
      _e$defaultSortAsc = e.defaultSortAsc,
      Ve = _e$defaultSortAsc === void 0 ? De.defaultSortAsc : _e$defaultSortAsc,
      _e$clearSelectedRows = e.clearSelectedRows,
      Ue = _e$clearSelectedRows === void 0 ? De.clearSelectedRows : _e$clearSelectedRows,
      _e$conditionalRowStyl = e.conditionalRowStyles,
      Ye = _e$conditionalRowStyl === void 0 ? De.conditionalRowStyles : _e$conditionalRowStyl,
      _e$theme = e.theme,
      Qe = _e$theme === void 0 ? De.theme : _e$theme,
      _e$customStyles = e.customStyles,
      Xe = _e$customStyles === void 0 ? De.customStyles : _e$customStyles,
      _e$direction = e.direction,
      Ze = _e$direction === void 0 ? De.direction : _e$direction,
      _e$onColumnOrderChang = e.onColumnOrderChange,
      et = _e$onColumnOrderChang === void 0 ? De.onColumnOrderChange : _e$onColumnOrderChang,
      _Je = Je(o, et, Ge, Ve),
      tt = _Je.tableColumns,
      nt = _Je.draggingColumnId,
      ot = _Je.handleDragStart,
      at = _Je.handleDragEnter,
      lt = _Je.handleDragOver,
      rt = _Je.handleDragLeave,
      it = _Je.handleDragEnd,
      st = _Je.defaultSortDirection,
      dt = _Je.defaultSortColumn,
      _l$useReducer = l.useReducer(C, {
    allSelected: !1,
    selectedCount: 0,
    selectedRows: [],
    selectedColumn: dt,
    toggleOnSelectedRowsChange: !1,
    sortDirection: st,
    currentPage: z,
    rowsPerPage: W,
    selectedRowsFlag: !1,
    contextMessage: De.contextMessage
  }),
      _l$useReducer2 = _slicedToArray(_l$useReducer, 2),
      _l$useReducer2$ = _l$useReducer2[0],
      ct = _l$useReducer2$.rowsPerPage,
      gt = _l$useReducer2$.currentPage,
      ut = _l$useReducer2$.selectedRows,
      pt = _l$useReducer2$.allSelected,
      bt = _l$useReducer2$.selectedCount,
      ft = _l$useReducer2$.selectedColumn,
      mt = _l$useReducer2$.sortDirection,
      ht = _l$useReducer2$.toggleOnSelectedRowsChange,
      wt = _l$useReducer2[1],
      _L$persistSelectedOnS = L.persistSelectedOnSort,
      xt = _L$persistSelectedOnS === void 0 ? !1 : _L$persistSelectedOnS,
      _L$persistSelectedOnP = L.persistSelectedOnPageChange,
      Ct = _L$persistSelectedOnP === void 0 ? !1 : _L$persistSelectedOnP,
      yt = !(!_ || !Ct && !xt),
      vt = de && !X && n.length > 0,
      Rt = Y || _e,
      St = l.useMemo(function () {
    return function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "default";
      var o = Ke[t] ? t : n;
      return qe({
        table: {
          style: {
            color: (a = Ke[o]).text.primary,
            backgroundColor: a.background.default
          }
        },
        tableWrapper: {
          style: {
            display: "table"
          }
        },
        header: {
          style: {
            fontSize: "22px",
            color: a.text.primary,
            backgroundColor: a.background.default,
            minHeight: "56px",
            paddingLeft: "16px",
            paddingRight: "8px"
          }
        },
        subHeader: {
          style: {
            backgroundColor: a.background.default,
            minHeight: "52px"
          }
        },
        head: {
          style: {
            color: a.text.primary,
            fontSize: "12px",
            fontWeight: 500
          }
        },
        headRow: {
          style: {
            backgroundColor: a.background.default,
            minHeight: "52px",
            borderBottomWidth: "1px",
            borderBottomColor: a.divider.default,
            borderBottomStyle: "solid"
          },
          denseStyle: {
            minHeight: "32px"
          }
        },
        headCells: {
          style: {
            paddingLeft: "16px",
            paddingRight: "16px"
          },
          draggingStyle: {
            cursor: "move"
          }
        },
        contextMenu: {
          style: {
            backgroundColor: a.context.background,
            fontSize: "18px",
            fontWeight: 400,
            color: a.context.text,
            paddingLeft: "16px",
            paddingRight: "8px",
            transform: "translate3d(0, -100%, 0)",
            transitionDuration: "125ms",
            transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
            willChange: "transform"
          },
          activeStyle: {
            transform: "translate3d(0, 0, 0)"
          }
        },
        cells: {
          style: {
            paddingLeft: "16px",
            paddingRight: "16px",
            wordBreak: "break-word"
          },
          draggingStyle: {}
        },
        rows: {
          style: {
            fontSize: "13px",
            fontWeight: 400,
            color: a.text.primary,
            backgroundColor: a.background.default,
            minHeight: "48px",
            "&:not(:last-of-type)": {
              borderBottomStyle: "solid",
              borderBottomWidth: "1px",
              borderBottomColor: a.divider.default
            }
          },
          denseStyle: {
            minHeight: "32px"
          },
          selectedHighlightStyle: {
            "&:nth-of-type(n)": {
              color: a.selected.text,
              backgroundColor: a.selected.default,
              borderBottomColor: a.background.default
            }
          },
          highlightOnHoverStyle: {
            color: a.highlightOnHover.text,
            backgroundColor: a.highlightOnHover.default,
            transitionDuration: "0.15s",
            transitionProperty: "background-color",
            borderBottomColor: a.background.default,
            outlineStyle: "solid",
            outlineWidth: "1px",
            outlineColor: a.background.default
          },
          stripedStyle: {
            color: a.striped.text,
            backgroundColor: a.striped.default
          }
        },
        expanderRow: {
          style: {
            color: a.text.primary,
            backgroundColor: a.background.default
          }
        },
        expanderCell: {
          style: {
            flex: "0 0 48px"
          }
        },
        expanderButton: {
          style: {
            color: a.button.default,
            fill: a.button.default,
            backgroundColor: "transparent",
            borderRadius: "2px",
            transition: "0.25s",
            height: "100%",
            width: "100%",
            "&:hover:enabled": {
              cursor: "pointer"
            },
            "&:disabled": {
              color: a.button.disabled
            },
            "&:hover:not(:disabled)": {
              cursor: "pointer",
              backgroundColor: a.button.hover
            },
            "&:focus": {
              outline: "none",
              backgroundColor: a.button.focus
            },
            svg: {
              margin: "auto"
            }
          }
        },
        pagination: {
          style: {
            color: a.text.secondary,
            fontSize: "13px",
            minHeight: "56px",
            backgroundColor: a.background.default,
            borderTopStyle: "solid",
            borderTopWidth: "1px",
            borderTopColor: a.divider.default
          },
          pageButtonsStyle: {
            borderRadius: "50%",
            height: "40px",
            width: "40px",
            padding: "8px",
            margin: "px",
            cursor: "pointer",
            transition: "0.4s",
            color: a.button.default,
            fill: a.button.default,
            backgroundColor: "transparent",
            "&:disabled": {
              cursor: "unset",
              color: a.button.disabled,
              fill: a.button.disabled
            },
            "&:hover:not(:disabled)": {
              backgroundColor: a.button.hover
            },
            "&:focus": {
              outline: "none",
              backgroundColor: a.button.focus
            }
          }
        },
        noData: {
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: a.text.primary,
            backgroundColor: a.background.default
          }
        },
        progress: {
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: a.text.primary,
            backgroundColor: a.background.default
          }
        }
      }, e);
      var a;
    }(Xe, Qe);
  }, [Xe, Qe]),
      Et = l.useMemo(function () {
    return Object.assign({}, "auto" !== Ze && {
      dir: Ze
    });
  }, [Ze]),
      Ot = l.useMemo(function () {
    if (Fe) return n;

    if ((null == ft ? void 0 : ft.sortFunction) && "function" == typeof ft.sortFunction) {
      var _e4 = ft.sortFunction,
          _t5 = mt === a.ASC ? _e4 : function (t, n) {
        return -1 * _e4(t, n);
      };

      return _toConsumableArray(n).sort(_t5);
    }

    return function (e, t, n, o) {
      return t ? o && "function" == typeof o ? o(e.slice(0), t, n) : e.slice(0).sort(function (e, o) {
        var a, l;

        if ("string" == typeof t ? (a = d(e, t), l = d(o, t)) : (a = t(e), l = t(o)), "asc" === n) {
          if (a < l) return -1;
          if (a > l) return 1;
        }

        if ("desc" === n) {
          if (a > l) return -1;
          if (a < l) return 1;
        }

        return 0;
      }) : e;
    }(n, null == ft ? void 0 : ft.selector, mt, je);
  }, [Fe, ft, mt, n, je]),
      Pt = l.useMemo(function () {
    if (de && !_) {
      var _e5 = gt * ct,
          _t6 = _e5 - ct;

      return Ot.slice(_t6, _e5);
    }

    return Ot;
  }, [gt, de, _, ct, Ot]),
      kt = l.useCallback(function (e) {
    wt(e);
  }, []),
      Dt = l.useCallback(function (e) {
    wt(e);
  }, []),
      Ht = l.useCallback(function (e) {
    wt(e);
  }, []),
      $t = l.useCallback(function (e, t) {
    return Pe(e, t);
  }, [Pe]),
      jt = l.useCallback(function (e, t) {
    return ke(e, t);
  }, [ke]),
      Ft = l.useCallback(function (e) {
    return wt({
      type: "CHANGE_PAGE",
      page: e,
      paginationServer: _,
      visibleOnly: O,
      persistSelectedOnPageChange: Ct
    });
  }, [_, Ct, O]),
      Tt = l.useCallback(function (e) {
    var t = p(M || Pt.length, e),
        n = b(gt, t);
    _ || Ft(n), wt({
      type: "CHANGE_ROWS_PER_PAGE",
      page: n,
      rowsPerPage: e
    });
  }, [gt, Ft, _, M, Pt.length]);

  if (de && !_ && Ot.length > 0 && 0 === Pt.length) {
    var _e6 = p(Ot.length, ct),
        _t7 = b(gt, _e6);

    Ft(_t7);
  }

  Le(function () {
    F({
      allSelected: pt,
      selectedCount: bt,
      selectedRows: ut
    });
  }, [ht]), Le(function () {
    $e(ft, mt);
  }, [ft, mt]), Le(function () {
    A(gt, M || Ot.length);
  }, [gt]), Le(function () {
    I(ct, gt);
  }, [ct]), Le(function () {
    Ft(z);
  }, [z, N]), Le(function () {
    if (de && _ && M > 0) {
      var _e7 = p(M, ct),
          _t8 = b(gt, _e7);

      gt !== _t8 && Ft(_t8);
    }
  }, [M]), l.useEffect(function () {
    wt({
      type: "CLEAR_SELECTED_ROWS",
      selectedRowsFlag: Ue
    });
  }, [x, Ue]), l.useEffect(function () {
    if (!P) return;
    var e = Ot.filter(function (e) {
      return P(e);
    }),
        t = x ? e.slice(0, 1) : e;
    wt({
      type: "SELECT_MULTIPLE_ROWS",
      keyField: c,
      selectedRows: t,
      totalRows: Ot.length,
      mergeSelections: yt
    });
  }, [n, P]);
  var It = O ? Pt : Ot,
      At = Ct || x || R;
  return l.createElement(t.ThemeProvider, {
    theme: St
  }, !re && (!!r || !!i) && l.createElement(be, {
    title: r,
    actions: i,
    showMenu: !fe,
    selectedCount: bt,
    direction: Ze,
    contextActions: he,
    contextComponent: Ee,
    contextMessage: me
  }), ce && l.createElement(we, {
    align: ge,
    wrapContent: ue
  }, pe), l.createElement(Ce, Object.assign({
    responsive: Q,
    fixedHeader: ie,
    fixedHeaderScrollHeight: se
  }, Et), l.createElement(ve, null, X && !ee && l.createElement(ye, null, Z), l.createElement(v, {
    disabled: ne,
    className: "rdt_Table",
    role: "table"
  }, !ae && (!!ee || Ot.length > 0 && !X) && l.createElement(S, {
    className: "rdt_TableHead",
    role: "rowgroup",
    fixedHeader: ie
  }, l.createElement(E, {
    className: "rdt_TableHeadRow",
    role: "row",
    dense: m
  }, w && (At ? l.createElement(H, {
    style: {
      flex: "0 0 48px"
    }
  }) : l.createElement(le, {
    allSelected: pt,
    selectedRows: ut,
    selectableRowsComponent: D,
    selectableRowsComponentProps: $,
    selectableRowDisabled: k,
    rowData: It,
    keyField: c,
    mergeSelections: yt,
    onSelectAllRows: Dt
  })), Oe && !Me && l.createElement(Re, null), tt.map(function (e) {
    return l.createElement(oe, {
      key: e.id,
      column: e,
      selectedColumn: ft,
      disabled: X || 0 === Ot.length,
      pagination: de,
      paginationServer: _,
      persistSelectedOnSort: xt,
      selectableRowsVisibleOnly: O,
      sortDirection: mt,
      sortIcon: He,
      sortServer: Fe,
      onSort: kt,
      onDragStart: ot,
      onDragOver: lt,
      onDragEnd: it,
      onDragEnter: at,
      onDragLeave: rt,
      draggingColumnId: nt
    });
  }))), !Ot.length && !X && l.createElement(Se, null, te), X && ee && l.createElement(ye, null, Z), !X && Ot.length > 0 && l.createElement(xe, {
    className: "rdt_TableBody",
    role: "rowgroup"
  }, Pt.map(function (e, t) {
    var n = s(e, c),
        o = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return "number" != typeof e && (!e || 0 === e.length);
    }(n) ? t : n,
        a = h(e, ut, c),
        r = !!(Oe && We && We(e)),
        i = !!(Oe && Ae && Ae(e));
    return l.createElement(J, {
      id: o,
      key: o,
      keyField: c,
      "data-row-id": o,
      columns: tt,
      row: e,
      rowCount: Ot.length,
      rowIndex: t,
      selectableRows: w,
      expandableRows: Oe,
      expandableIcon: T,
      highlightOnHover: u,
      pointerOnHover: f,
      dense: m,
      expandOnRowClicked: ze,
      expandOnRowDoubleClicked: Ne,
      expandableRowsComponent: Te,
      expandableRowsComponentProps: Ie,
      expandableRowsHideExpander: Me,
      defaultExpanderDisabled: i,
      defaultExpanded: r,
      expandableInheritConditionalStyles: Be,
      conditionalRowStyles: Ye,
      selected: a,
      selectableRowsHighlight: y,
      selectableRowsComponent: D,
      selectableRowsComponentProps: $,
      selectableRowDisabled: k,
      selectableRowsSingle: x,
      striped: g,
      onRowExpandToggled: j,
      onRowClicked: $t,
      onRowDoubleClicked: jt,
      onSelectedRow: Ht,
      draggingColumnId: nt,
      onDragStart: ot,
      onDragOver: lt,
      onDragEnd: it,
      onDragEnter: at,
      onDragLeave: rt
    });
  }))))), vt && l.createElement("div", null, l.createElement(Rt, {
    onChangePage: Ft,
    onChangeRowsPerPage: Tt,
    rowCount: M || Ot.length,
    currentPage: gt,
    rowsPerPage: ct,
    direction: Ze,
    paginationRowsPerPageOptions: B,
    paginationIconLastPage: G,
    paginationIconFirstPage: V,
    paginationIconNext: U,
    paginationIconPrevious: q,
    paginationComponentOptions: K
  })));
});
exports.STOP_PROP_TAG = "allowRowEvents", exports.createTheme = function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
  var t = arguments.length > 1 ? arguments[1] : undefined;
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "default";
  return Ke[e] || (Ke[e] = qe(Ke[n], t || {})), Ke[e] = qe(Ke[e], t || {}), Ke[e];
}, exports.default = Qe, exports.defaultThemes = Ke;